import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../../../../src/client/App'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage"

import OrganizationMembershipsPage from '../../../../src/admin/organization-membership/OrganizationMembershipsPage'
import SiteAccessGatePage from '../../../../src/client/site-access/SiteAccessGatePage'
import ReceptionLandingPage from '../../../../src/gedoba/reception/ReceptionPage'
import AboutPage from '../../../../src/landing-page/AboutPage'
import PrivacyPolicyPage from '../../../../src/landing-page/PrivacyPolicyPage'
import TermsOfServicePage from '../../../../src/landing-page/TermsOfServicePage'
import RoadmapPage from '../../../../src/landing-page/RoadmapPage'
import ContactPage from '../../../../src/landing-page/ContactPage'
import LoginPage from '../../../../src/auth/LoginPage'
import { Signup as SignupPage } from '../../../../src/auth/SignupPage'
import { RequestPasswordResetPage } from '../../../../src/auth/email-and-pass/RequestPasswordResetPage'
import { PasswordResetPage } from '../../../../src/auth/email-and-pass/PasswordResetPage'
import { EmailVerificationPage } from '../../../../src/auth/email-and-pass/EmailVerificationPage'
import PendingApprovalPage from '../../../../src/auth/PendingApprovalPage'
import AccountPage from '../../../../src/user/AccountPage'
import NotificationsPage from '../../../../src/gedoba/notification/NotificationsPage'
import ReceptionPage from '../../../../src/gedoba/reception/ReceptionPage'
import DemoSchedulerPage from '../../../../src/dashboard/DemoAppPage'
import PricingPage from '../../../../src/payment/PricingPage'
import CheckoutPage from '../../../../src/payment/CheckoutPage'
import FileUploadPage from '../../../../src/file-upload/FileUploadPage'
import AdminDashboardPage from '../../../../src/admin/AdminDashboardPage'
import AdminUsersPage from '../../../../src/admin/dashboards/users/UsersDashboardPage'
import AdminUserDetailPage from '../../../../src/admin/dashboards/users/UserDetailPage'
import AdminUserEditPage from '../../../../src/admin/dashboards/users/UserEditPage'
import AdminUserRecycleBinPage from '../../../../src/admin/dashboards/users/UserRecycleBinPage'
import AdminUserApprovalsPage from '../../../../src/admin/dashboards/users/UserApprovalsPage'
import AdminSettingsPage from '../../../../src/admin/elements/settings/SettingsPage'
import AdminCalendarPage from '../../../../src/admin/elements/calendar/CalendarPage'
import AdminUIButtonsPage from '../../../../src/admin/elements/ui-elements/ButtonsPage'
import OrganizationTypesPage from '../../../../src/admin/OrganizationTypesPage'
import AddOrganizationTypePage from '../../../../src/gedoba/organizationType/AddOrganizationTypePage'
import ViewOrganizationTypePage from '../../../../src/gedoba/organizationType/ViewOrganizationTypePage'
import EditOrganizationTypePage from '../../../../src/gedoba/organizationType/EditOrganizationTypePage'
import LocationTypesPage from '../../../../src/admin/LocationTypesPage'
import AddLocationTypePage from '../../../../src/gedoba/locationType/AddLocationTypePage'
import ViewLocationTypePage from '../../../../src/gedoba/locationType/ViewLocationTypePage'
import EditLocationTypePage from '../../../../src/gedoba/locationType/EditLocationTypePage'
import SectionsPage from '../../../../src/admin/SectionsPage'
import AddSectionPage from '../../../../src/gedoba/section/AddSectionPage'
import ViewSectionPage from '../../../../src/gedoba/section/ViewSectionPage'
import EditSectionPage from '../../../../src/gedoba/section/EditSectionPage'
import ServiceTypesPage from '../../../../src/admin/ServiceTypesPage'
import ServiceTypesNewPage from '../../../../src/admin/ServiceTypesNewPage'
import ServiceDefinitionsPage from '../../../../src/admin/ServiceDefinitionsPage'
import ServiceDefinitionsNewPage from '../../../../src/admin/ServiceDefinitionsNewPage'
import TopicTypesPage from '../../../../src/admin/TopicTypesPage'
import TopicTypesNewPage from '../../../../src/admin/TopicTypesNewPage'
import TopicsPage from '../../../../src/admin/TopicsPage'
import TopicsNewPage from '../../../../src/admin/TopicsNewPage'
import OccasionTypesPage from '../../../../src/admin/OccasionTypesPage'
import OccasionsPage from '../../../../src/admin/OccasionsPage'
import OrganizationsPage from '../../../../src/admin/OrganizationsPage'
import AddOrganizationPage from '../../../../src/gedoba/organization/AddOrganizationPage'
import ViewOrganizationPage from '../../../../src/gedoba/organization/ViewOrganizationPage'
import EditOrganizationPage from '../../../../src/gedoba/organization/EditOrganizationPage'
import FieldConfigsPage from '../../../../src/admin/field-configs/FieldConfigsPage'
import AddFieldConfigPage from '../../../../src/admin/field-configs/AddFieldConfigPage'
import EditFieldConfigPage from '../../../../src/admin/field-configs/EditFieldConfigPage'
import GlobalSettingsPage from '../../../../src/admin/global-settings/GlobalSettingsPage'
import UserRolesPage from '../../../../src/admin/user-roles/UserRolesPage'
import TaxonomyPage from '../../../../src/admin/taxonomy/TaxonomyPage'
import AdminMessagesPage from '../../../../src/admin/dashboards/messages/MessagesPage'
import TestDashboardPage from '../../../../src/gedoba/TestDashboardPage'
import OrganizationsByTypePage from '../../../../src/gedoba/organization/OrganizationsByTypePage'
import OrgDashboardPage from '../../../../src/gedoba/organization/OrgDashboardPage'
import OrgAboutPage from '../../../../src/gedoba/organization/OrgAboutPage'
import LocationDashboardPage from '../../../../src/gedoba/location/pages/LocationDashboardPage'
import LocationAboutPage from '../../../../src/gedoba/location/pages/LocationAboutPage'
import LocationInformationDeskPage from '../../../../src/gedoba/location/pages/LocationInformationDeskPage'
import LocationNoticeBoardPage from '../../../../src/gedoba/notice-board/NoticeBoardPage'
import LocationEventsPage from '../../../../src/gedoba/events/EventsPage'
import LocationFlagshipEventsPage from '../../../../src/gedoba/events/FlagshipEventsPage'
import LocationTenantsPage from '../../../../src/gedoba/tenants/TenantsPage'
import LocationFoodCourtPage from '../../../../src/gedoba/food-court/FoodCourtPage'
import LocationFacilitiesPage from '../../../../src/gedoba/facilities/components/FacilitiesPage'
import LocationServicesPage from '../../../../src/gedoba/services/ServicesPage'
import LocationBuySellPage from '../../../../src/gedoba/buy-sell/BuySellPage'
import LocationRequestOfferPage from '../../../../src/gedoba/request-offer/RequestOfferPage'
import LocationLostFoundPage from '../../../../src/gedoba/lost-found/LostFoundPage'
import LocationTransportationPage from '../../../../src/gedoba/transportation/TransportationPage'
import OrgNoticeBoardPage from '../../../../src/gedoba/organization/pages/OrgNoticeBoardPage'
import OrgEventsPage from '../../../../src/gedoba/organization/pages/OrgEventsPage'
import OrgTenantsPage from '../../../../src/gedoba/organization/pages/OrgTenantsPage'
import OrgFoodCourtPage from '../../../../src/gedoba/organization/pages/OrgFoodCourtPage'
import OrgFacilitiesPage from '../../../../src/gedoba/organization/pages/OrgFacilitiesPage'
import OrgServicesPage from '../../../../src/gedoba/organization/pages/OrgServicesPage'
import OrgBuySellPage from '../../../../src/gedoba/organization/pages/OrgBuySellPage'
import OrgRequestOfferPage from '../../../../src/gedoba/organization/pages/OrgRequestOfferPage'
import OrgLostFoundPage from '../../../../src/gedoba/organization/pages/OrgLostFoundPage'
import OrgTransportationPage from '../../../../src/gedoba/organization/pages/OrgTransportationPage'
import OrganizationsRedirectPage from '../../../../src/gedoba/organization/OrganizationsRedirectPage'
import AdminLocationsPage from '../../../../src/gedoba/location/AdminLocationsPage'
import ViewLocationPage from '../../../../src/gedoba/location/ViewLocationPage'
import CreateLocationPage from '../../../../src/gedoba/location/CreateLocationPage'
import EditLocationPage from '../../../../src/gedoba/location/EditLocationPage'
import AdminLocationItemsPage from '../../../../src/gedoba/location/AdminLocationItemsPage'
import EventsPage from '../../../../src/gedoba/events/EventsPage'
import FlagshipEventsPage from '../../../../src/gedoba/events/FlagshipEventsPage'
import AddEventPage from '../../../../src/gedoba/events/AddEventPage'
import EditEventPage from '../../../../src/gedoba/events/EditEventPage'
import ViewEventPage from '../../../../src/gedoba/events/ViewEventPage'
import TenantsPage from '../../../../src/gedoba/tenants/TenantsPage'
import AddTenantPage from '../../../../src/gedoba/tenants/AddTenantPage'
import EditTenantPage from '../../../../src/gedoba/tenants/EditTenantPage'
import ViewTenantPage from '../../../../src/gedoba/tenants/ViewTenantPage'
import NoticeBoardPage from '../../../../src/gedoba/notice-board/NoticeBoardPage'
import AddNoticePage from '../../../../src/gedoba/notice-board/AddNoticePage'
import EditNoticePage from '../../../../src/gedoba/notice-board/EditNoticePage'
import ViewNoticePage from '../../../../src/gedoba/notice-board/ViewNoticePage'
import FacilitiesPage from '../../../../src/gedoba/facilities/components/FacilitiesPage'
import AddFacilityPage from '../../../../src/gedoba/facilities/components/AddFacilityPage'
import EditFacilityPage from '../../../../src/gedoba/facilities/components/EditFacilityPage'
import ViewFacilityPage from '../../../../src/gedoba/facilities/components/ViewFacilityPage'
import BuySellPage from '../../../../src/gedoba/buy-sell/BuySellPage'
import AddBuySellPage from '../../../../src/gedoba/buy-sell/AddBuySellPage'
import EditBuySellPage from '../../../../src/gedoba/buy-sell/EditBuySellPage'
import ViewBuySellPage from '../../../../src/gedoba/buy-sell/ViewBuySellPage'
import FoodCourtPage from '../../../../src/gedoba/food-court/FoodCourtPage'
import AddFoodCourtPage from '../../../../src/gedoba/food-court/AddFoodCourtPage'
import EditFoodCourtPage from '../../../../src/gedoba/food-court/EditFoodCourtPage'
import ViewFoodCourtPage from '../../../../src/gedoba/food-court/ViewFoodCourtPage'
import RequestOfferPage from '../../../../src/gedoba/request-offer/RequestOfferPage'
import AddRequestOfferPage from '../../../../src/gedoba/request-offer/AddRequestOfferPage'
import EditRequestOfferPage from '../../../../src/gedoba/request-offer/EditRequestOfferPage'
import ViewRequestOfferPage from '../../../../src/gedoba/request-offer/ViewRequestOfferPage'
import TransportationPage from '../../../../src/gedoba/transportation/TransportationPage'
import AddTransportationPage from '../../../../src/gedoba/transportation/AddTransportationPage'
import EditTransportationPage from '../../../../src/gedoba/transportation/EditTransportationPage'
import ViewTransportationPage from '../../../../src/gedoba/transportation/ViewTransportationPage'
import LostFoundPage from '../../../../src/gedoba/lost-found/LostFoundPage'
import AddLostFoundPage from '../../../../src/gedoba/lost-found/AddLostFoundPage'
import EditLostFoundPage from '../../../../src/gedoba/lost-found/EditLostFoundPage'
import ViewLostFoundPage from '../../../../src/gedoba/lost-found/ViewLostFoundPage'
import ServicesPage from '../../../../src/gedoba/services/ServicesPage'
import AddServicePage from '../../../../src/gedoba/services/AddServicePage'
import EditServicePage from '../../../../src/gedoba/services/EditServicePage'
import ViewServicePage from '../../../../src/gedoba/services/ViewServicePage'
import SearchPage from '../../../../src/gedoba/search/SearchPage'
import OccasionListPage from '../../../../src/gedoba/occasions/OccasionListPage'
import OccasionDetailPage from '../../../../src/gedoba/occasions/OccasionDetailPage'
import TopicListPage from '../../../../src/gedoba/topics/TopicListPage'
import TopicDetailPage from '../../../../src/gedoba/topics/TopicDetailPage'
import ServiceDiscoveryPage from '../../../../src/gedoba/services/ServiceDiscoveryPage'
import ServiceDefinitionListPage from '../../../../src/gedoba/services/ServiceDefinitionList'
import ServiceDefinitionDetailPage from '../../../../src/gedoba/services/ServiceDefinitionDetail'
import ServiceOfferingListPage from '../../../../src/gedoba/services/ServiceOfferingList'
import ServiceOfferingDetailPage from '../../../../src/gedoba/services/ServiceOfferingDetail'
import PermissionManagementPage from '../../../../src/admin/permissions/PermissionManagementPage'
import ApprovalDashboardPage from '../../../../src/admin/approvals/ApprovalDashboardPage'
import RecycleBinPage from '../../../../src/admin/recycle-bin/RecycleBinPage'
import AdminCanadaPage from '../../../../src/admin/CanadaPage'
import AdminFeedbackPage from '../../../../src/admin/dashboards/feedback/FeedbackPage'
import InformationDeskPage from '../../../../src/gedoba/information-desk/InformationDeskPage'
import OrgInformationDeskPage from '../../../../src/gedoba/organization/pages/OrgInformationDeskPage'
import { NotFoundPage } from '../../../../src/client/components/NotFoundPage'

import { OAuthCallbackPage } from "./auth/pages/OAuthCallback"

import { DefaultRootErrorBoundary } from './components/DefaultRootErrorBoundary'

import { routes } from 'wasp/client/router'

export const routeNameToRouteComponent = {
  OrganizationMembershipsRoute: createAuthRequiredPage(OrganizationMembershipsPage),
  LandingPageRoute: SiteAccessGatePage,
  ReceptionLandingRoute: ReceptionLandingPage,
  AboutRoute: AboutPage,
  PrivacyRoute: PrivacyPolicyPage,
  TermsRoute: TermsOfServicePage,
  RoadmapRoute: RoadmapPage,
  ContactRoute: ContactPage,
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  PendingApprovalRoute: PendingApprovalPage,
  AccountRoute: createAuthRequiredPage(AccountPage),
  NotificationsRoute: createAuthRequiredPage(NotificationsPage),
  DashboardRoute: ReceptionPage,
  DemoSchedulerRoute: createAuthRequiredPage(DemoSchedulerPage),
  PricingPageRoute: PricingPage,
  CheckoutRoute: createAuthRequiredPage(CheckoutPage),
  FileUploadRoute: createAuthRequiredPage(FileUploadPage),
  AdminRoute: createAuthRequiredPage(AdminDashboardPage),
  AdminUsersRoute: createAuthRequiredPage(AdminUsersPage),
  AdminUserDetailRoute: createAuthRequiredPage(AdminUserDetailPage),
  AdminUserEditRoute: createAuthRequiredPage(AdminUserEditPage),
  AdminUserRecycleBinRoute: createAuthRequiredPage(AdminUserRecycleBinPage),
  AdminUserApprovalsRoute: createAuthRequiredPage(AdminUserApprovalsPage),
  AdminSettingsRoute: createAuthRequiredPage(AdminSettingsPage),
  AdminCalendarRoute: createAuthRequiredPage(AdminCalendarPage),
  AdminUIButtonsRoute: createAuthRequiredPage(AdminUIButtonsPage),
  AdminOrganizationTypesRoute: createAuthRequiredPage(OrganizationTypesPage),
  AdminAddOrganizationTypeRoute: createAuthRequiredPage(AddOrganizationTypePage),
  AdminViewOrganizationTypeRoute: createAuthRequiredPage(ViewOrganizationTypePage),
  AdminEditOrganizationTypeRoute: createAuthRequiredPage(EditOrganizationTypePage),
  AdminLocationTypesRoute: createAuthRequiredPage(LocationTypesPage),
  AdminAddLocationTypeRoute: createAuthRequiredPage(AddLocationTypePage),
  AdminViewLocationTypeRoute: createAuthRequiredPage(ViewLocationTypePage),
  AdminEditLocationTypeRoute: createAuthRequiredPage(EditLocationTypePage),
  AdminSectionsRoute: createAuthRequiredPage(SectionsPage),
  AdminAddSectionRoute: createAuthRequiredPage(AddSectionPage),
  AdminViewSectionRoute: createAuthRequiredPage(ViewSectionPage),
  AdminEditSectionRoute: createAuthRequiredPage(EditSectionPage),
  AdminServiceTypesRoute: createAuthRequiredPage(ServiceTypesPage),
  AdminServiceTypesNewRoute: createAuthRequiredPage(ServiceTypesNewPage),
  AdminServiceDefinitionsRoute: createAuthRequiredPage(ServiceDefinitionsPage),
  AdminServiceDefinitionsNewRoute: createAuthRequiredPage(ServiceDefinitionsNewPage),
  AdminTopicTypesRoute: createAuthRequiredPage(TopicTypesPage),
  AdminTopicTypesNewRoute: createAuthRequiredPage(TopicTypesNewPage),
  AdminTopicsRoute: createAuthRequiredPage(TopicsPage),
  AdminTopicsNewRoute: createAuthRequiredPage(TopicsNewPage),
  AdminOccasionTypesRoute: createAuthRequiredPage(OccasionTypesPage),
  AdminOccasionsRoute: createAuthRequiredPage(OccasionsPage),
  AdminOrganizationsRoute: createAuthRequiredPage(OrganizationsPage),
  AdminAddOrganizationRoute: createAuthRequiredPage(AddOrganizationPage),
  AdminViewOrganizationRoute: createAuthRequiredPage(ViewOrganizationPage),
  AdminEditOrganizationRoute: createAuthRequiredPage(EditOrganizationPage),
  AdminFieldConfigsRoute: createAuthRequiredPage(FieldConfigsPage),
  AdminAddFieldConfigRoute: createAuthRequiredPage(AddFieldConfigPage),
  AdminEditFieldConfigRoute: createAuthRequiredPage(EditFieldConfigPage),
  AdminGlobalSettingsRoute: createAuthRequiredPage(GlobalSettingsPage),
  UserRolesRoute: createAuthRequiredPage(UserRolesPage),
  AdminTaxonomyRoute: createAuthRequiredPage(TaxonomyPage),
  AdminMessagesRoute: createAuthRequiredPage(AdminMessagesPage),
  TestDashboardRoute: TestDashboardPage,
  OrganizationsByTypeRoute: OrganizationsByTypePage,
  OrganizationProfileRoute: OrgDashboardPage,
  OrgAboutRoute: OrgAboutPage,
  OrgNoticeBoardRoute: OrgNoticeBoardPage,
  OrgEventsRoute: OrgEventsPage,
  OrgTenantsRoute: OrgTenantsPage,
  OrgFoodCourtRoute: OrgFoodCourtPage,
  OrgFacilitiesRoute: OrgFacilitiesPage,
  OrgServicesRoute: OrgServicesPage,
  OrgBuySellRoute: OrgBuySellPage,
  OrgBuySellAddRoute: createAuthRequiredPage(AddBuySellPage),
  OrgRequestOfferRoute: OrgRequestOfferPage,
  OrgRequestOfferAddRoute: createAuthRequiredPage(AddRequestOfferPage),
  OrgLostFoundRoute: OrgLostFoundPage,
  OrgLostFoundAddRoute: createAuthRequiredPage(AddLostFoundPage),
  OrgTransportationRoute: OrgTransportationPage,
  OrgTransportationAddRoute: createAuthRequiredPage(AddTransportationPage),
  LocationProfileRoute: LocationDashboardPage,
  LocationAboutRoute: LocationAboutPage,
  LocationInformationDeskRoute: LocationInformationDeskPage,
  LocationNoticeBoardRoute: LocationNoticeBoardPage,
  LocationNoticeAddRoute: createAuthRequiredPage(AddNoticePage),
  LocationViewNoticeRoute: ViewNoticePage,
  LocationEditNoticeRoute: createAuthRequiredPage(EditNoticePage),
  LocationEventsRoute: LocationEventsPage,
  LocationFlagshipEventsRoute: LocationFlagshipEventsPage,
  LocationEventsAddRoute: createAuthRequiredPage(AddEventPage),
  LocationViewEventRoute: ViewEventPage,
  LocationEditEventRoute: createAuthRequiredPage(EditEventPage),
  LocationTenantsRoute: LocationTenantsPage,
  LocationTenantsAddRoute: createAuthRequiredPage(AddTenantPage),
  LocationViewTenantRoute: ViewTenantPage,
  LocationEditTenantRoute: createAuthRequiredPage(EditTenantPage),
  LocationFoodCourtRoute: LocationFoodCourtPage,
  LocationFoodCourtAddRoute: createAuthRequiredPage(AddFoodCourtPage),
  LocationViewFoodCourtRoute: ViewFoodCourtPage,
  LocationEditFoodCourtRoute: createAuthRequiredPage(EditFoodCourtPage),
  LocationFacilitiesRoute: LocationFacilitiesPage,
  LocationFacilitiesAddRoute: createAuthRequiredPage(AddFacilityPage),
  LocationViewFacilityRoute: ViewFacilityPage,
  LocationEditFacilityRoute: createAuthRequiredPage(EditFacilityPage),
  LocationServicesRoute: LocationServicesPage,
  LocationServicesAddRoute: createAuthRequiredPage(AddServicePage),
  LocationViewServiceRoute: ViewServicePage,
  LocationEditServiceRoute: createAuthRequiredPage(EditServicePage),
  LocationBuySellRoute: LocationBuySellPage,
  LocationBuySellAddRoute: createAuthRequiredPage(AddBuySellPage),
  LocationViewBuySellRoute: ViewBuySellPage,
  LocationEditBuySellRoute: createAuthRequiredPage(EditBuySellPage),
  LocationRequestOfferRoute: LocationRequestOfferPage,
  LocationRequestOfferAddRoute: createAuthRequiredPage(AddRequestOfferPage),
  LocationViewRequestOfferRoute: ViewRequestOfferPage,
  LocationEditRequestOfferRoute: createAuthRequiredPage(EditRequestOfferPage),
  LocationLostFoundRoute: LocationLostFoundPage,
  LocationLostFoundAddRoute: createAuthRequiredPage(AddLostFoundPage),
  LocationViewLostFoundRoute: ViewLostFoundPage,
  LocationEditLostFoundRoute: createAuthRequiredPage(EditLostFoundPage),
  LocationTransportationRoute: LocationTransportationPage,
  LocationTransportationAddRoute: createAuthRequiredPage(AddTransportationPage),
  LocationViewTransportationRoute: ViewTransportationPage,
  LocationEditTransportationRoute: createAuthRequiredPage(EditTransportationPage),
  OrganizationsRoute: OrganizationsRedirectPage,
  AdminLocationsRoute: createAuthRequiredPage(AdminLocationsPage),
  ViewLocationRoute: createAuthRequiredPage(ViewLocationPage),
  CreateLocationRoute: createAuthRequiredPage(CreateLocationPage),
  EditLocationRoute: createAuthRequiredPage(EditLocationPage),
  AdminLocationItemsRoute: createAuthRequiredPage(AdminLocationItemsPage),
  EventsRoute: EventsPage,
  FlagshipEventsRoute: FlagshipEventsPage,
  AddEventRoute: createAuthRequiredPage(AddEventPage),
  EditEventRoute: createAuthRequiredPage(EditEventPage),
  ViewEventRoute: ViewEventPage,
  TenantsRoute: TenantsPage,
  AddTenantRoute: createAuthRequiredPage(AddTenantPage),
  EditTenantRoute: createAuthRequiredPage(EditTenantPage),
  ViewTenantRoute: ViewTenantPage,
  NoticeBoardRoute: NoticeBoardPage,
  AddNoticeRoute: createAuthRequiredPage(AddNoticePage),
  EditNoticeRoute: createAuthRequiredPage(EditNoticePage),
  ViewNoticeRoute: ViewNoticePage,
  FacilitiesRoute: FacilitiesPage,
  AddFacilityRoute: createAuthRequiredPage(AddFacilityPage),
  EditFacilityRoute: createAuthRequiredPage(EditFacilityPage),
  ViewFacilityRoute: ViewFacilityPage,
  BuySellRoute: BuySellPage,
  AddBuySellRoute: createAuthRequiredPage(AddBuySellPage),
  EditBuySellRoute: createAuthRequiredPage(EditBuySellPage),
  ViewBuySellRoute: ViewBuySellPage,
  FoodCourtRoute: FoodCourtPage,
  AddFoodCourtRoute: createAuthRequiredPage(AddFoodCourtPage),
  EditFoodCourtRoute: createAuthRequiredPage(EditFoodCourtPage),
  ViewFoodCourtRoute: ViewFoodCourtPage,
  RequestOfferRoute: RequestOfferPage,
  AddRequestOfferRoute: createAuthRequiredPage(AddRequestOfferPage),
  EditRequestOfferRoute: createAuthRequiredPage(EditRequestOfferPage),
  ViewRequestOfferRoute: ViewRequestOfferPage,
  TransportationRoute: TransportationPage,
  AddTransportationRoute: createAuthRequiredPage(AddTransportationPage),
  EditTransportationRoute: createAuthRequiredPage(EditTransportationPage),
  ViewTransportationRoute: ViewTransportationPage,
  LostFoundRoute: LostFoundPage,
  AddLostFoundRoute: createAuthRequiredPage(AddLostFoundPage),
  EditLostFoundRoute: createAuthRequiredPage(EditLostFoundPage),
  ViewLostFoundRoute: ViewLostFoundPage,
  ServicesRoute: ServicesPage,
  AddServiceRoute: createAuthRequiredPage(AddServicePage),
  EditServiceRoute: createAuthRequiredPage(EditServicePage),
  ViewServiceRoute: ViewServicePage,
  SearchRoute: SearchPage,
  OccasionsRoute: OccasionListPage,
  OccasionDetailRoute: OccasionDetailPage,
  TopicsRoute: TopicListPage,
  TopicDetailRoute: TopicDetailPage,
  ServiceDiscoveryRoute: ServiceDiscoveryPage,
  ServiceDefinitionsRoute: ServiceDefinitionListPage,
  ServiceDefinitionDetailRoute: ServiceDefinitionDetailPage,
  ServiceOfferingsRoute: ServiceOfferingListPage,
  ServiceOfferingDetailRoute: ServiceOfferingDetailPage,
  PermissionManagementRoute: createAuthRequiredPage(PermissionManagementPage),
  ApprovalDashboardRoute: createAuthRequiredPage(ApprovalDashboardPage),
  RecycleBinRoute: createAuthRequiredPage(RecycleBinPage),
  AdminCanadaRoute: createAuthRequiredPage(AdminCanadaPage),
  AdminFeedbackRoute: createAuthRequiredPage(AdminFeedbackPage),
  InformationDeskRoute: InformationDeskPage,
  OrgInformationDeskRoute: OrgInformationDeskPage,
  NotFoundRoute: NotFoundPage,
} as const;

const waspDefinedRoutes = [
  {
    path: "/oauth/callback",
    Component: OAuthCallbackPage,
  },
]
const userDefinedRoutes = Object.entries(routes).map(([routeKey, route]) => {
  return {
    path: route.to,
    Component: routeNameToRouteComponent[routeKey],
  }
})

const browserRouter = createBrowserRouter([{
  path: '/',
  element: <App />,
  ErrorBoundary: DefaultRootErrorBoundary,
  children: [
    ...waspDefinedRoutes,
    ...userDefinedRoutes,
  ],
}], {
  basename: '/',
})

export const router = <RouterProvider router={browserRouter} />
